import { useTranslation } from "react-i18next";
import { Phone, Mail, Clock } from "lucide-react";
import { CONTACT_EMAIL, WHATSAPP_DISPLAY, WHATSAPP_NUMBER } from "../../lib/api";
import LanguageSwitcher from "./LanguageSwitcher";

export default function TopBar() {
  const { t } = useTranslation();
  return (
    <div className="bg-navy text-white/80 text-xs" data-testid="top-bar">
      <div className="container-site flex items-center justify-between py-2.5">
        <div className="hidden md:flex items-center gap-2 tracking-wide">
          <span className="text-gold font-medium">—</span>
          <span className="uppercase tracking-[0.14em]">{t("tagline")}</span>
        </div>
        <div className="flex items-center gap-5 ml-auto">
          <a href={`tel:+${WHATSAPP_NUMBER}`} className="flex items-center gap-1.5 hover:text-gold transition-colors" data-testid="topbar-phone">
            <Phone size={12} />
            <span>{WHATSAPP_DISPLAY}</span>
          </a>
          <a href={`mailto:${CONTACT_EMAIL}`} className="hidden md:flex items-center gap-1.5 hover:text-gold transition-colors" data-testid="topbar-email">
            <Mail size={12} />
            <span>{CONTACT_EMAIL}</span>
          </a>
          <div className="hidden lg:flex items-center gap-1.5">
            <Clock size={12} className="text-[#39c8c1]" />
            <span>{t("contact_24h")}</span>
          </div>
          <LanguageSwitcher dark />
        </div>
      </div>
    </div>
  );
}
